import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheck,
  faXmark,
  faEnvelope,
  faCircleExclamation,
  faBan,
} from "@fortawesome/sharp-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  AppealState,
  AppealStatus,
  getAppealStateFromAppealStatus,
} from "../../types/appealState";
import styles from "./status-indicator.module.scss";

interface StatusIndicatorProps {
  status: AppealStatus;
  sponsorshipExpiredTimestamp?: string | null;
}

interface StatusDisplay {
  icon: IconDefinition;
  text: string;
  className: string;
}

const getStatusDisplay = (appealState: AppealState): StatusDisplay => {
  switch (appealState) {
    case AppealState.Expired:
      return {
        icon: faXmark,
        text: "Expired",
        className: styles.statusExpired,
      };
    case AppealState.ReferralInProgress:
      return {
        icon: faClock,
        text: "Referral in progress",
        className: styles.statusMuted,
      };
    case AppealState.Approved:
      return {
        icon: faCheck,
        text: "Approved",
        className: styles.statusSuccess,
      };
    case AppealState.NotApproved:
      return {
        icon: faXmark,
        text: "Not Approved",
        className: styles.statusError,
      };
    case AppealState.Submitted:
      return {
        icon: faCheck,
        text: "Submitted",
        className: styles.statusSubmitted,
      };
    case AppealState.InSupport:
      return {
        icon: faCircleExclamation,
        text: "In Support",
        className: styles.statusWarning,
      };
    case AppealState.InProgress:
      return {
        icon: faClock,
        text: "In Progress",
        className: styles.statusInProgress,
      };
    case AppealState.Closed:
      return {
        icon: faBan,
        text: "Closed",
        className: styles.statusClosed,
      };
    case AppealState.Referred:
    default:
      return {
        icon: faEnvelope,
        text: "Referred",
        className: styles.statusReferred,
      };
  }
};

export function StatusIndicator({
  status,
  sponsorshipExpiredTimestamp,
}: StatusIndicatorProps) {
  const appealState = getAppealStateFromAppealStatus(
    status,
    Boolean(sponsorshipExpiredTimestamp),
  );
  const statusDisplay = getStatusDisplay(appealState);

  return (
    <div className={`${styles.statusIndicator} ${statusDisplay.className}`}>
      <FontAwesomeIcon icon={statusDisplay.icon} className={styles.icon} />
      <span className={styles.statusText}>{statusDisplay.text}</span>
    </div>
  );
}
